const MAX_CONCURRENT_STORAGE_KEY = 'upload.maxConcurrent';
const LAUNCH_INTERVAL_MS_STORAGE_KEY = 'upload.launchIntervalMs';

export const UPLOAD_MAX_CONCURRENT_DEFAULT = 4;
export const UPLOAD_MAX_CONCURRENT_MIN = 1;
export const UPLOAD_MAX_CONCURRENT_MAX = 10;

export const UPLOAD_LAUNCH_INTERVAL_MS_DEFAULT = 0;
export const UPLOAD_LAUNCH_INTERVAL_MS_OPTIONS = [0, 100, 250, 500, 1000] as const;

function clampInt(value: number, min: number, max: number): number {
  const intValue = Number.isFinite(value) ? Math.floor(value) : min;
  return Math.min(max, Math.max(min, intValue));
}

export function getUploadMaxConcurrent(): number {
  if (typeof window === 'undefined') return UPLOAD_MAX_CONCURRENT_DEFAULT;

  try {
    const raw = window.localStorage.getItem(MAX_CONCURRENT_STORAGE_KEY);
    if (!raw) return UPLOAD_MAX_CONCURRENT_DEFAULT;

    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed)) return UPLOAD_MAX_CONCURRENT_DEFAULT;

    return clampInt(
      parsed,
      UPLOAD_MAX_CONCURRENT_MIN,
      UPLOAD_MAX_CONCURRENT_MAX
    );
  } catch {
    return UPLOAD_MAX_CONCURRENT_DEFAULT;
  }
}

export function setUploadMaxConcurrent(value: number): void {
  if (typeof window === 'undefined') return;

  try {
    const clamped = clampInt(
      value,
      UPLOAD_MAX_CONCURRENT_MIN,
      UPLOAD_MAX_CONCURRENT_MAX
    );
    window.localStorage.setItem(MAX_CONCURRENT_STORAGE_KEY, String(clamped));
  } catch {
    // Best-effort: ignore storage failures.
  }
}

export function getUploadLaunchIntervalMs(): number {
  if (typeof window === 'undefined') return UPLOAD_LAUNCH_INTERVAL_MS_DEFAULT;

  try {
    const raw = window.localStorage.getItem(LAUNCH_INTERVAL_MS_STORAGE_KEY);
    if (!raw) return UPLOAD_LAUNCH_INTERVAL_MS_DEFAULT;

    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed)) return UPLOAD_LAUNCH_INTERVAL_MS_DEFAULT;

    if ((UPLOAD_LAUNCH_INTERVAL_MS_OPTIONS as readonly number[]).includes(parsed)) {
      return parsed;
    }
    return UPLOAD_LAUNCH_INTERVAL_MS_DEFAULT;
  } catch {
    return UPLOAD_LAUNCH_INTERVAL_MS_DEFAULT;
  }
}

export function setUploadLaunchIntervalMs(value: number): void {
  if (typeof window === 'undefined') return;

  try {
    const next = (UPLOAD_LAUNCH_INTERVAL_MS_OPTIONS as readonly number[]).includes(
      value
    )
      ? value
      : UPLOAD_LAUNCH_INTERVAL_MS_DEFAULT;
    window.localStorage.setItem(LAUNCH_INTERVAL_MS_STORAGE_KEY, String(next));
  } catch {
    // Best-effort: ignore storage failures.
  }
}

